// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 854 ? "pdfjs" : chunkId) + "." + {"48":"aa024f52","854":"2cd67039"}[chunkId] + ".chunk.js";
};